import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

import { customHeaders, supersetUrl } from '../../../../../../../Containers/Config/index.js';
import SUPERSET_CANVAS_CONFIG from '../../../../../../../Components/SupersetCanvas/superset.canvas.config.js';
import { normalizeChart } from '../../../../../../../Components/SupersetCanvas/helpers/vizMapping.js';
import { SUPERSET_CANVAS_CHART_LIST, SUPERSET_CANVAS_CHART_LIST_ERROR, SUPERSET_CANVAS_CHART_LIST_SUCCESS } from '../../../../../actionType.js';
import apiCall from '../../../../../apiCall.js';

const PAGE_SIZE = SUPERSET_CANVAS_CONFIG.CHART_LIST_PAGE_SIZE;

// Superset paginates /api/v1/chart/ — walk every page so the panel
// shows the complete catalogue rather than the first 100 charts.
function* supersetCanvasChartList({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const baseUrl = (payload?.baseUrl || supersetUrl || '').replace(/\/$/, '');
    let page = 0;
    let all_ = [];

    // Hard page ceiling — a misbehaving instance must not spin forever.
    for (let guard = 0; guard < 50; guard += 1) {
      const response = yield call(apiCall, {
        url: `${baseUrl}${SUPERSET_CANVAS_CONFIG.ENDPOINTS.CHART_LIST}`,
        method: 'GET',
        headers: { ...filteredHeaders, ...payload?.headers },
        params: {
          q: {
            page,
            page_size: PAGE_SIZE,
            order_column: 'slice_name',
            order_direction: 'asc',
            filters: [],
          },
        },
      });

      if (response?.status !== 200) {
        yield put({
          type: SUPERSET_CANVAS_CHART_LIST_ERROR,
          payload: response?.data?.message || response?.message || 'Failed to load charts from Superset',
        });
        return;
      }

      const { result = [], count = 0 } = response.data || {};
      all_ = all_.concat(result);
      page += 1;
      if (all_.length >= count || result.length < PAGE_SIZE) break;
    }

    yield put({
      type: SUPERSET_CANVAS_CHART_LIST_SUCCESS,
      payload: all_.map(normalizeChart),
    });
  } catch (error) {
    yield put({ type: SUPERSET_CANVAS_CHART_LIST_ERROR, payload: error?.message || error });
  }
}

export function* watchSupersetCanvasChartList() {
  yield takeEvery(SUPERSET_CANVAS_CHART_LIST, supersetCanvasChartList);
}

function* supersetCanvasChartListSaga() {
  yield all([fork(watchSupersetCanvasChartList)]);
}

export default supersetCanvasChartListSaga;
